import LeadList from './LeadList'
import LeadCreate from './LeadCreate'
import LeadEdit from './LeadEdit'
import LeadShow from './LeadShow'
import PersonIcon from '@mui/icons-material/Person'

const leads = {
  list: LeadList,
  create: LeadCreate,
  show: LeadShow,
  edit: LeadEdit,
  icon: PersonIcon,
}

export default leads
